<template>
  <TopBar />
  <section id="breadcrumbs" class="breadcrumbs">
    <div class="container">
      <div class="col-lg-12">
        <ol>
          <li class="text-danger"><a href="/">Início</a></li>
        </ol>
        <h2>Creditall Desenvolvedores</h2>
      </div>
    </div>
  </section>

  <section id="contato" class="contato">
    <div style="margin-top: 50px"></div>
    <div class="container">
    <div class="row" data-aos="fade-up">
        <div class="col-12 mb-4">
          <div style="background: #be2d2d; color: #fff; padding: 12px 20px; border-radius: 6px; font-weight: bold; font-size: 18px; text-align: center;">
            NOVAS APIs
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal13">
                  <i class="bi bi-code-slash"></i>
                  <h3>Autenticação</h3>
                  <p class="emailText">Login</p>
                </a>
              </div>
            </div>
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal14">
                  <i class="bi bi-code-slash"></i>
                  <h3>Pré-Análise de Crédito</h3>
                </a>
              </div>
            </div>
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal15">
                  <i class="bi bi-code-slash"></i>
                  <h3>Análise de Crédito</h3>
                </a>
              </div>
            </div>
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal16">
                  <i class="bi bi-code-slash"></i>
                  <h3>Simulador de Vendas</h3>
                </a>
              </div>
            </div>
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal17">
                  <i class="bi bi-code-slash"></i>
                  <h3>Finalizar Venda</h3>
                </a>
              </div>
            </div>
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal18">
                  <i class="bi bi-code-slash"></i>
                  <h3>Listagem de Parcelas</h3>
                </a>
              </div>
            </div>
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal19">
                  <i class="bi bi-code-slash"></i>
                  <h3>Cadastro de Webhooks</h3>
                </a>
              </div>
            </div>
          <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal20">
                  <i class="bi bi-code-slash"></i>
                  <h3>Webhooks</h3>
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <hr>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal1">
                  <i class="bi bi-code-slash"></i>
                  <h3>Crediário WebService</h3>
                  <p class="emailText">Situação Cadastral</p>
                </a>
              </div>
            </div>

            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal2">
                  <i class="bi bi-code-slash"></i>
                  <h3>Crediário WebService Cadastro QrCode</h3>
                </a>
              </div>
            </div>

            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal3">
                  <i class="bi bi-code-slash"></i>
                  <h3>XML / Envio Token</h3>
                </a>
              </div>
            </div>

            <div class="col-xs-6 col-md-3" align="center">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal4">
                  <i class="bi bi-code-slash"></i>
                  <h3>Crediário WebService Autorizador Token</h3>
                </a>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal5">
                  <i class="bi bi-code-slash"></i>
                  <h3>XML Intenção de Compra</h3>
                </a>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal6">
                  <i class="bi bi-code-slash"></i>
                  <h3>Envio/Retorno XML Localize</h3>
                </a>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal7">
                  <i class="bi bi-code-slash"></i>
                  <h3>Envio/Retorno XML Mosaico de Crédito</h3>
                </a>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal8">
                  <i class="bi bi-code-slash"></i>
                  <h3>Recebimento</h3>
                  <p>Carnê e Boleto</p>
                </a>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal9">
                  <i class="bi bi-code-slash"></i>
                  <h3>CreditallPay</h3>
                  <p class="emailText">Anti-fraude</p>
                </a>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-box mb-5">
                 <a href="" data-toggle="modal" data-target="#modal10">
                  <i class="bi bi-code-slash"></i>
                  <h3>Envio/Retorno XML</h3>
                  <p>Pré-Análise</p>
                </a>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal11">
                  <i class="bi bi-code-slash"></i>
                  <h3>Retorno XML Compras Cartão / Boleto WEB</h3>
                </a>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-box mb-5">
                <a href="" data-toggle="modal" data-target="#modal12">
                  <i class="bi bi-code-slash"></i>
                  <h3>Retorno XML Consulta Cheque</h3>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<!---------------------------------------------------------------------------------------------------------------------------------->
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Crediário WebService</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Situação Cadastral</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/credital/webservices/statuscrediario.php.</p>
        <p style="font-size: 13px;">URL HOMOLOGAÇÃO: https://www.siscredit.com.br/demonstracao/webserviceshomologacao/statuscrediario.php.</p>

        <p style="font-size: 13px;"><strong>• Nota</strong></p>
        <table border="0" class=" table table-bordered " style="display:;">
          <tbody>
            <tr>
              <td class="tit_tab" style="width:80px;" align="center"><strong style="font-size: 13px;">&lt;Status&gt;</strong></td>
              <td class="tit_tab"><strong style="font-size: 13px;">&lt;Mensagem&gt;</strong></td>
            </tr>
            <tr>
              <td class="tit_tab" align="center" style="font-size: 13px;">0</td>
              <td class="tit_tab"><strong style="font-size: 13px;">Cadastro não localizado</strong></td>
            </tr>
            <tr>
              <td class="tit_tab" align="center" style="font-size: 13px;">1</td>
              <td class="tit_tab"><strong style="font-size: 13px;">Cadastro OK</strong></td>
            </tr>
            <tr>
              <td class="tit_tab" align="center" style="font-size: 13px;">2</td>
              <td class="tit_tab"><strong style="font-size: 13px;">Cadastro Bloqueado</strong></td>
            </tr>
          </tbody>
        </table>
        <br>

              <h6>PARAMETROS DE ENVIO:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
  &lt;?xml version="1.0" encoding="utf-8"?&gt;
  &lt;StatusCrediario xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"&gt;
    &lt;Cliente&gt;
      &lt;Chave&gt;FFfaf2a**************6787146195&lt;/Chave&gt;
    &lt;/Cliente&gt;
    &lt;Consumidor&gt;
      &lt;CpfCnpj&gt;999999999&lt;/CpfCnpj&gt;
    &lt;/Consumidor&gt;
  &lt;/StatusCrediario&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO:</h6>
              <pre>
  &lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
  &lt;Resposta&gt;
    &lt;Dados&gt;
              &lt;Numero_Controle&gt;999999&lt;/Numero_Controle&gt;
              &lt;Data&gt;2019-01-01&lt;/Data&gt;
              &lt;Hora&gt;2019-01-01 11:00:00&lt;/Hora&gt;
              &lt;CpfCnpj&gt;999.999.999-99&lt;/CpfCnpj&gt;
              &lt;Status&gt;0&lt;/Status&gt;
              &lt;Mensagem&gt;Cadastro OK&lt;/Mensagem&gt;
    &lt;/Dados&gt;
  &lt;/Resposta&gt;

              </pre>

              <pre>
  &lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
  &lt;Resposta&gt;
    &lt;Dados&gt;
              &lt;Numero_Controle&gt;999999&lt;/Numero_Controle&gt;
              &lt;Data&gt;2019-01-01&lt;/Data&gt;
              &lt;Hora&gt;2019-01-01 11:00:00&lt;/Hora&gt;
              &lt;CpfCnpj&gt;999.999.999-99&lt;/CpfCnpj&gt;
              &lt;Status&gt;0&lt;/Status&gt;
              &lt;Mensagem&gt;Cadastro não Localizado&lt;/Mensagem&gt;
    &lt;/Dados&gt;
  &lt;/Resposta&gt;

              </pre>



      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" >Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal2">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Crediário WebService - Cadastro QrCode</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Situação Cadastral</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/credital/webservices/cadastrocrediario.php.</p>
        <p style="font-size: 13px;">URL HOMOLOGAÇÃO: https://www.siscredit.com.br/demonstracao/webserviceshomologacao/cadastrocrediario.php.</p>
        <p style="font-size: 13px;">Método: POST.</p><br>

        <h6><strong>• Situações (Status)</strong></h6>
        <p style="font-size: 13px;">1 - Negado Cadastro</p>
        <p style="font-size: 13px;">2 - Aprovado Cadastro</p>

      <br>
      <h6><strong>Tabela de Parâmetros</strong></h6>
        <table width="757" border="0" class=" table table-bordered table-striped table-responsive" style="display:;">
      <tbody>
        <tr align="center" bgcolor="#9e9e9e">
          <td width="74" class="tit_tab">&nbsp;</td>
          <td width="154" class="tit_tab"><strong>Parâmetros</strong></td>
          <td width="77" align="center" class="tit_tab"><strong>Obrigatório</strong></td>
          <td width="237" class="tit_tab"><strong>Exemplo</strong></td>
          <td width="127" class="tit_tab"><strong>Descrição</strong></td>
          <td width="62" class="tit_tab"><strong>Tamanho</strong></td>
        </tr>
        <tr>
          <td colspan="6" align="center" class="tit_tab1">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">Cliente</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Chave</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">99753f5fc430u284c5a2ba5ea48bf316</td>
          <td style="font-size: 12px">Código Gerado pela Creditall</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">Consumidor</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">CpfCnpj</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">99000999000901.</td>
          <td style="font-size: 12px">CPF, CNPJ </td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">CpfRepresentante</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">99911199911</td>
          <td style="font-size: 12px">CPF obrigatório quando Cnpj</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px"></td>
          <td style="font-size: 12px">Documento</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Tipo</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">RG ou CNH</td>
          <td style="font-size: 12px">Tipo Documento</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Numero</td>
          <td style="font-size: 12px" align="center">não</td>
          <td style="font-size: 12px">77788899</td>
          <td style="font-size: 12px">Número do campo tipo(RG ou CNH)</td>
          <td style="font-size: 12px" align="center">11</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Nascimento</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">1980-08-10</td>
          <td style="font-size: 12px">Data Nascimento Cpf informado</td>
          <td style="font-size: 12px" align="center"> (Y-m-a)</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Endereço</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Cep</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">99.999-999</td>
          <td style="font-size: 12px">CEP do comprador</td>
          <td style="font-size: 12px" align="center">8</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Numero</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">1234</td>
          <td style="font-size: 12px">Nº do comprador</td>
          <td style="font-size: 12px" align="center">50</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Telefones Celular</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">DDD</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">99</td>
          <td style="font-size: 12px">DDD</td>
          <td style="font-size: 12px" align="center">2</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Numero</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">999999999</td>
          <td style="font-size: 12px">Celular do comprador</td>
          <td style="font-size: 12px" align="center">10</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Telefones Fixo</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px" align="center">&nbsp;</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">DDD</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">99</td>
          <td style="font-size: 12px">DDD</td>
          <td style="font-size: 12px" align="center">2</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">Numero</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">999999999</td>
          <td style="font-size: 12px">Telefone do comprador</td>
          <td style="font-size: 12px" align="center">10</td>
        </tr>
        <tr>
          <td style="font-size: 12px">&nbsp;</td>
          <td style="font-size: 12px">email</td>
          <td style="font-size: 12px" align="center">sim</td>
          <td style="font-size: 12px">email.comprador@dominio.com.br</td>
          <td style="font-size: 12px">Email do comprador</td>
          <td style="font-size: 12px" align="center">250</td>
        </tr>
      </tbody>
    </table>
        <br>

              <h6>EXEMPLO DE ENVIO TOKEN CPF:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;CadastroCrediario
 xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"&gt;
  &lt;Cliente&gt;
    &lt;Chave&gt;gxfaf2a102ac0457b310e96787146103&lt;/Chave&gt;
  &lt;/Cliente&gt;
  &lt;Consumidor&gt;
    &lt;CpfCnpj&gt;99999999999&lt;/CpfCnpj&gt;
    &lt;Documento&gt;
      &lt;Tipo&gt;RG&lt;/Tipo&gt;
      &lt;Numero&gt;1009999&lt;/Numero&gt;
    &lt;/Documento&gt;
    &lt;Nascimento&gt;1980-08-10&lt;/Nascimento&gt;
    &lt;Endereco&gt;
      &lt;Cep&gt;11333999&lt;/Cep&gt;
      &lt;Numero&gt;2469&lt;/Numero&gt;
    &lt;/Endereco&gt;
    &lt;Telefones&gt;
      &lt;Celular&gt;
        &lt;DDD&gt;41&lt;/DDD&gt;
        &lt;Numero&gt;99999999&lt;/Numero&gt;
      &lt;/Celular&gt;
      &lt;Fixo&gt;
        &lt;DDD&gt;41&lt;/DDD&gt;
        &lt;Numero&gt;33333333&lt;/Numero&gt;
      &lt;/Fixo&gt;
    &lt;/Telefones&gt;
    &lt;Email&gt;contatoteste@gmail.com.br&lt;/Email&gt;
  &lt;/Consumidor&gt;
&lt;/CadastroCrediario&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE ENVIO TOKEN CNPJ:</h6>
              <pre>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;CadastroCrediario
 xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"&gt;
  &lt;Cliente&gt;
    &lt;Chave&gt;gxfaf2a102ac0457b310e96787146103&lt;/Chave&gt;
  &lt;/Cliente&gt;
  &lt;Consumidor&gt;
    &lt;CpfCnpj&gt;99999999999999&lt;/CpfCnpj&gt;
    &lt;CpfRepresentante&gt;99999999999&lt;/CpfRepresentante&gt;
    &lt;Documento&gt;
      &lt;Tipo&gt;RG&lt;/Tipo&gt;
      &lt;Numero&gt;1009999&lt;/Numero&gt;
    &lt;/Documento&gt;
    &lt;Nascimento&gt;1980-08-10&lt;/Nascimento&gt;
    &lt;Endereco&gt;
      &lt;Cep&gt;11333999&lt;/Cep&gt;
      &lt;Numero&gt;2469&lt;/Numero&gt;
    &lt;/Endereco&gt;
    &lt;Telefones&gt;
      &lt;Celular&gt;
        &lt;DDD&gt;41&lt;/DDD&gt;
        &lt;Numero&gt;99999999&lt;/Numero&gt;
      &lt;/Celular&gt;
      &lt;Fixo&gt;
        &lt;DDD&gt;41&lt;/DDD&gt;
        &lt;Numero&gt;33333333&lt;/Numero&gt;
      &lt;/Fixo&gt;
    &lt;/Telefones&gt;
    &lt;Email&gt;contatoteste@gmail.com.br&lt;/Email&gt;
  &lt;/Consumidor&gt;
&lt;/CadastroCrediario&gt;

              </pre>

              <br>
              <h6>EXEMPLOS DE RETORNO EM XML:</h6><strong style="font-size: 14px"><br>:: CADASTRO APROVADO</strong>
              <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
&lt;Resposta&gt;
  &lt;Dados&gt;
    &lt;Numero_Controle&gt;99999&lt;/Numero_Controle&gt;
    &lt;Data&gt;2016-08-01&lt;/Data&gt;
    &lt;Hora&gt;2016-08-01 10:04:06&lt;/Hora&gt;
    &lt;Status&gt;2&lt;/Status&gt;
    &lt;Situacao&gt;APROVADO&lt;/Situacao&gt;
    &lt;CpfCnpj&gt;000.999.99-97&lt;/Cpf&gt;
    &lt;Nome&gt;MARIA  SILVA&lt;/Nome&gt;
    &lt;Nome_Mae&gt;MARIA FERREIRA &lt;/Nome_Mae&gt;
    &lt;DATA_FUNDACAO&gt;&lt;/DATA_FUNDACAO&gt;
    &lt;Data_Obito&gt;&lt;/Data_Obito&gt;
    &lt;Beneficiario&gt;&lt;/Beneficiario&gt;
    &lt;Valor_Beneficiario&gt;&lt;/Valor_Beneficiario&gt;
    &lt;Qr_Code&gt;NDYxNC84MDAxLzI2L01ESTVOamswTURJNU1UST0=&lt;/Qr_Code&gt;
    &lt;Mensagem&gt;APROVADO CODIGO:5&lt;/Mensagem&gt;
    &lt;Composicao&gt;
      &lt;Risco&gt;6.3&lt;/Risco&gt;
      &lt;Endividamento_Futuro&gt;MEDIO RISCO&lt;/Endividamento_Futuro&gt;
      &lt;Limite&gt;4633.2&lt;/Limite&gt;
      &lt;Limte_Maximo_Parcela&gt;1544.4&lt;/Limte_Maximo_Parcela&gt;
      &lt;Maximo_Segmento&gt;30000&lt;/Maximo_Segmento&gt;
      &lt;Gastos_Creditall&gt;0&lt;/Gastos_Creditall&gt;
      &lt;Saldo_Limite&gt;4633.2&lt;/Saldo_Limite&gt;
      &lt;Saldo_Maximo_Parcela&gt;1544.4&lt;/Saldo_Maximo_Parcela&gt;
    &lt;/Composicao&gt;
  &lt;/Dados&gt;
&lt;/Resposta&gt;

              </pre>
              <br>
              <strong style="font-size: 14px">:: CADASTRO NEGADO</strong>
    <br>
    <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
&lt;Resposta&gt;
  &lt;Dados&gt;
    &lt;Numero_Controle&gt;99999&lt;/Numero_Controle&gt;
    &lt;Data&gt;2016-08-01&lt;/Data&gt;
    &lt;Hora&gt;2016-08-01 10:04:06&lt;/Hora&gt;
    &lt;Status&gt;1&lt;/Status&gt;
    &lt;Situacao&gt;NEGADO&lt;/Situacao&gt;
    &lt;CpfCnpj&gt;000.999.99-97&lt;/Cpf&gt;
    &lt;Nome&gt;MARIA  SILVA&lt;/Nome&gt;
    &lt;Nome_Mae&gt;MARIA FERREIRA &lt;/Nome_Mae&gt;
    &lt;DATA_FUNDACAO&gt;&lt;/DATA_FUNDACAO&gt;
    &lt;Data_Obito&gt;&lt;/Data_Obito&gt;
    &lt;Beneficiario&gt;&lt;/Beneficiario&gt;
    &lt;Valor_Beneficiario&gt;&lt;/Valor_Beneficiario&gt;
    &lt;Mensagem&gt;Compra não avalizada. Consta restrição no documento consultado. Oriente o Consumidor a Procurar o Servicos Ao Consumidor. &lt;/Mensagem&gt;
    &lt;Composicao&gt;
      &lt;Risco&gt;6.3&lt;/Risco&gt;
      &lt;Endividamento_Futuro&gt;MEDIO RISCO&lt;/Endividamento_Futuro&gt;
      &lt;Limite&gt;4633.2&lt;/Limite&gt;
      &lt;Limte_Maximo_Parcela&gt;1544.4&lt;/Limte_Maximo_Parcela&gt;
      &lt;Maximo_Segmento&gt;30000&lt;/Maximo_Segmento&gt;
      &lt;Gastos_Creditall&gt;0&lt;/Gastos_Creditall&gt;
      &lt;Saldo_Limite&gt;4633.2&lt;/Saldo_Limite&gt;
      &lt;Saldo_Maximo_Parcela&gt;1544.4&lt;/Saldo_Maximo_Parcela&gt;
    &lt;/Composicao&gt;
  &lt;/Dados&gt;
&lt;/Resposta&gt;
</pre>
<br>
    <strong style="font-size: 14px">:: ALERTAS</strong>
    <br>
    <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
&lt;Resposta&gt;
	&lt;Erros&gt;
		&lt;Erro&gt;DDD Celular diferente do DDD Fixo&lt;/Erro&gt;
	&lt;/Erros&gt;
&lt;/Resposta&gt;
</pre>
    <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
&lt;Resposta&gt;
	&lt;Erros&gt;
		&lt;Erro&gt;Data de Nascimento inválida&lt;/Erro&gt;
	&lt;/Erros&gt;
&lt;/Resposta&gt;
</pre>



      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal3">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">XML / Envio Token</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Situação Cadastral</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/credital/webservices/smscrediario.php.</p>
        <p style="font-size: 13px;">URL HOMOLOGAÇÃO: https://www.siscredit.com.br/demonstracao/webserviceshomologacao/smscrediario.php.</p><br>
        <p style="color:#D96363; font-size: 13px;"><strong>• O Token na Tag "&lt;Mensagem&gt;" somente será visualizado no ambiente de homologação.</strong></p>
        <br>

    <h6>Exemplo de Envio Token:</h6>
    <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;SmsCrediario xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"&gt;
	&lt;Cliente&gt;
		&lt;Chave&gt;a730456a264edbXXXXc3b82bd67cc4ea&lt;/Chave&gt;
	&lt;/Cliente&gt;
&lt;Consumidor&gt;
  &lt;CpfCnpj&gt;999999999&lt;/CpfCnpj&gt;
    &lt;Telefones&gt;
      &lt;Celular&gt;
        &lt;DDD&gt;41&lt;/DDD&gt;
        &lt;Numero&gt;999999999&lt;/Numero&gt;
      &lt;/Celular&gt;
    &lt;/Telefones&gt;
    &lt;NomeComprador&gt;João Maria José&lt;/NomeComprador&gt;
	&lt;/Consumidor&gt;
&lt;/SmsCrediario&gt;

</pre>
<br>

    <h6>EXEMPLO DE RETORNO:</h6>
    <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
&lt;Resposta&gt;
	&lt;Dados&gt;
            &lt;Numero_Controle&gt;999999&lt;/Numero_Controle&gt;
            &lt;Data&gt;2019-01-01&lt;/Data&gt;
            &lt;Hora&gt;2019-01-01 11:00:00&lt;/Hora&gt;
            &lt;CpfCnpj&gt;999.999.999-99&lt;/CpfCnpj&gt;
            &lt;Celular&gt;999999999&lt;/Celular&gt;
            &lt;Mensagem&gt;Token Enviado com Sucesso (99999)&lt;/Mensagem&gt;
	&lt;/Dados&gt;
&lt;/Resposta&gt;

</pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal4">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Crediário WebService - Autorizador Token</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Situação Cadastral</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/credital/webservices/consultacrediariotk.php.</p>
        <p style="font-size: 13px;">URL HOMOLOGAÇÃO: https://www.siscredit.com.br/demonstracao/webserviceshomologacao/consultacrediariotk.php.</p><br>
        <p style="color:#D96363; font-size: 13px;"><strong>• O Token na Tag "&lt;tokensms&gt;" deve ser informada pelo consumidor.</strong></p>
        <p style="color:#D96363; font-size: 13px;"><strong>• O Token na Tag "&lt;Adesao&gt;/&lt;Contrato&gt;/&lt;Fatura&gt;" adicionadas para impressão documentos.</strong></p>
        <br>

              <h6>EXEMPLO DE ENVIO:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
  &lt;ConsultaCrediario xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"&gt;
    &lt;Cliente&gt;
      &lt;Chave&gt;a730456a264edbXXXXc3b82bd67cc4ea&lt;/Chave&gt;
    &lt;/Cliente&gt;
    &lt;Consumidor&gt;
      &lt;CpfCnpj&gt;999999999&lt;/CpfCnpj&gt;
      &lt;Documento&gt;
        &lt;Tipo&gt;RG&lt;/Tipo&gt;
        &lt;Numero&gt;999999999&lt;/Numero&gt;
      &lt;/Documento&gt;
      &lt;Nascimento&gt;1999-01-01&lt;/Nascimento&gt;
      &lt;Endereco&gt;
        &lt;Cep&gt;81030000&lt;/Cep&gt;
        &lt;Numero&gt;81030000&lt;/Numero&gt;
      &lt;/Endereco&gt;
      &lt;Telefones&gt;
        &lt;Celular&gt;
          &lt;DDD&gt;41&lt;/DDD&gt;
          &lt;Numero&gt;999999999&lt;/Numero&gt;
        &lt;/Celular&gt;
	&lt;Fixo&gt;
          &lt;DDD&gt;41&lt;/DDD&gt;
          &lt;Numero&gt;999999999&lt;/Numero&gt;
        &lt;/Fixo&gt;
      &lt;/Telefones&gt;
      &lt;Email&gt;Contatoteste@gmail.com&lt;/Email&gt;
    &lt;/Consumidor&gt;
    &lt;Compra&gt;
      &lt;CodigoControle&gt;9999&lt;/CodigoControle&gt;
      &lt;tokensms&gt;090909&lt;/tokensms&gt;
      &lt;Segmento&gt;999&lt;/Segmento&gt;
      &lt;Valor&gt;109.99&lt;/Valor&gt;
      &lt;ValorTotal&gt;109.99&lt;/ValorTotal&gt;
      &lt;Parcelas&gt;1&lt;/Parcelas&gt;
      &lt;VencimentoPrimeiraParcela&gt;2019-01-01&lt;/VencimentoPrimeiraParcela&gt;
    &lt;/Compra&gt;
  &lt;/ConsultaCrediario&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO:</h6>
              <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
  &lt;Resposta&gt;
    &lt;Dados&gt;
      &lt;Numero_Controle&gt;999999&lt;/Numero_Controle&gt;
      &lt;Data&gt;2019-01-01&lt;/Data&gt;
      &lt;Hora&gt;2019-01-01 11:00:00&lt;/Hora&gt;
      &lt;Numero_Aprovacao&gt;339999&lt;/Numero_Aprovacao&gt;
      &lt;Status&gt;2&lt;/Status&gt;
      &lt;Situacao&gt;APROVADO&lt;/Situacao&gt;
      &lt;CpfCnpj&gt;999.999.999-99&lt;/CpfCnpj&gt;
      &lt;Nome&gt;João Maria José&lt;/Nome&gt;
      &lt;Nome_Mae&gt;Maria José João&lt;/Nome_Mae&gt;
      &lt;DATA_FUNDACAO&gt;&lt;/DATA_FUNDACAO&gt;
      &lt;Data_Obito&gt;&lt;/Data_Obito&gt;
      &lt;Beneficiario&gt;&lt;/Beneficiario&gt;
      &lt;Valor_Beneficiario&gt;&lt;/Valor_Beneficiario&gt;
      &lt;Mensagem&gt;APROVADO CODIGO:339999&lt;/Mensagem&gt;
      &lt;Adesao&gt;
        &lt;![CDATA[https://www.siscredit.com.br/credital/docbb/adesao_pdf.php?8001]] &gt;
      &lt;/Adesao&gt;
      &lt;Contrato&gt;
        &lt;![CDATA[https://www.siscredit.com.br/credital/docbb/duplicata_pdf.php?8001]] &gt;
      &lt;/Contrato&gt;
      &lt;Fatura&gt;
        &lt;![CDATA[https://www.siscredit.com.br/credital/docbb/adesao_pdf.php?8001]] &gt;
      &lt;/Fatura&gt;
      &lt;Parcelas&gt;
        &lt;Parcela&gt;
          &lt;parcela&gt;1&lt;/parcela&gt;
          &lt;Valor&gt;109.99&lt;/Valor&gt;
          &lt;Vencimento&gt;2019-04-10&lt;/Vencimento&gt;
          &lt;NOSSO_NUMERO&gt;000000616&lt;/NOSSO_NUMERO&gt;
        &lt;/Parcela&gt;
      &lt;/Parcelas&gt;
      &lt;Composicao&gt;
        &lt;Risco&gt;23.87&lt;/Risco&gt;
        &lt;Endividamento_Futuro&gt;MEDIO RISCO&lt;/Endividamento_Futuro&gt;
        &lt;Anotacoes_Restritivas&gt;&lt;/Anotacoes_Restritivas&gt;
        &lt;Limite&gt;3105&lt;/Limite&gt;
        &lt;Limte_Maximo_Parcela&gt;258.75&lt;/Limte_Maximo_Parcela&gt;
        &lt;Maximo_Segmento&gt;100000&lt;/Maximo_Segmento&gt;
        &lt;Gastos_Creditall&gt;0&lt;/Gastos_Creditall&gt;
        &lt;Saldo_Limite&gt;3105&lt;/Saldo_Limite&gt;
        &lt;Saldo_Maximo_Parcela&gt;258.75&lt;/Saldo_Maximo_Parcela&gt;
      &lt;/Composicao&gt;
     &lt;/Dados&gt;
  &lt;/Resposta&gt;

              </pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal5">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">XML Intenção de Compra</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Situação Cadastral</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/credital/webservices/intencaocompra.php.</p>
        <p style="font-size: 13px;">URL HOMOLOGAÇÃO: https://www.siscredit.com.br/demonstracao/webserviceshomologacao/intencaocompra.php.</p>
        <br>

              <h6>PARAMETROS DE ENVIO:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;IntencaoCompra xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"&gt;
  &lt;Cliente&gt;
    &lt;Chave&gt;d99456a264ehxb3978c3b82bd67cc9ea&lt;/Chave&gt;
  &lt;/Cliente&gt;
  &lt;Consumidor&gt;
    &lt;CpfCnpj&gt;09999988811&lt;/CpfCnpj&gt;
    &lt;Endereco&gt;
      &lt;Cep&gt;81720000&lt;/Cep&gt;
      &lt;Numero&gt;123&lt;/Numero&gt;
    &lt;/Endereco&gt;
    &lt;Telefones&gt;
      &lt;Celular&gt;
        &lt;DDD&gt;41&lt;/DDD&gt;
        &lt;Numero&gt;999988877&lt;/Numero&gt;
      &lt;/Celular&gt;
      &lt;Fixo&gt;
         &lt;DDD&gt;41&lt;/DDD&gt;
         &lt;Numero&gt;33332222&lt;/Numero&gt;
      &lt;/Fixo&gt;
    &lt;/Telefones&gt;
    &lt;Email&gt;email_exemple@gmail.com&lt;/Email&gt;
  &lt;/Consumidor&gt;
&lt;/IntencaoCompra&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
&lt;RESPOSTA&gt;
  &lt;Dados&gt;
    &lt;Numero_Controle&gt;390909&lt;/Numero_Controle&gt;
    &lt;Data&gt;2019-01-01&lt;/Data&gt;
    &lt;Hora&gt;2019-01-01 12:00:59&lt;/Hora&gt;
    &lt;CpfCnpj&gt;000.222.333-11&lt;/CpfCnpj&gt;
    &lt;Mensagem&gt;Registrado com Sucesso&lt;/Mensagem&gt;
  &lt;/Dados&gt;
&lt;/RESPOSTA&gt;

              </pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal6">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Envio/Retorno XML Localize</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Situação Cadastral</h6>
        <p style="font-size: 13px;">URL: https://www.siscredit.com.br/credital/webservices/mosaicolocaliza.php.</p>
        <br>

              <h6>PARAMETROS DE ENVIO:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
  &lt;localiza&gt;
    &lt;cpfcnpj&gt;99999999999&lt;/cpfcnpj&gt;
    &lt;login&gt;8001&lt;/login&gt;
    &lt;token&gt;gxfaf2a102ac0457b310e96787146103&lt;/token&gt;
    &lt;usuario&gt;Usuário&lt;/usuario&gt;
    &lt;consulta&gt;10&lt;/consulta&gt;
  &lt;/localiza&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
  &lt;RESPOSTA&gt;
    &lt;CONSULTA&gt;10&lt;/CONSULTA&gt;
    &lt;DADOS_CADASTRAL&gt;
      &lt;CPF&gt;999.999.999-99&lt;/CPF&gt;
      &lt;NOME&gt;NOME&lt;/NOME&gt;
      &lt;DATA_NASCIMENTO&gt;99/99/9999&lt;/DATA_NASCIMENTO&gt;
      &lt;VALOR_SALARIO&gt;1000.00&lt;/VALOR_SALARIO&gt;
      &lt;/DADOS_CADASTRAL&gt;
      &lt;DADOS_MAE&gt;
        &lt;NOME_MAE&gt;NOME DA MAE&lt;/NOME_MAE&gt;
      &lt;/DADOS_MAE&gt;
      &lt;ENDERECOS&gt;
        &lt;ENDERECO&gt;
          &lt;LOGRADOURO&gt;RUA&lt;/LOGRADOURO&gt;
          &lt;NUMERO&gt;999&lt;/NUMERO&gt;
          &lt;BAIRRO&gt;BAIRRO&lt;/BAIRRO&gt;
          &lt;CIDADE&gt;CIDADE&lt;/CIDADE&gt;
          &lt;ESTADO&gt;UF&lt;/ESTADO&gt;
          &lt;CEP&gt;99999999&lt;/CEP&gt;
        &lt;/ENDERECO&gt;
      &lt;/ENDERECOS&gt;
      &lt;TELEFONES&gt;
        &lt;TELEFONE&gt;
          &lt;NUMERO&gt;4199999999&lt;/NUMERO&gt;
        &lt;/TELEFONE&gt;
      &lt;/TELEFONES&gt;
      &lt;EMAILS&gt;
        &lt;EMAIL&gt;
          &lt;DESCRICAO&gt;email@teste.com.br&lt;/DESCRICAO&gt;
        &lt;/EMAIL&gt;
      &lt;/EMAILS&gt;
      &lt;IRMAOS&gt;
        &lt;IRMAO&gt;
          &lt;NOME&gt;NOME DO IRMAO&lt;/NOME&gt;
        &lt;/IRMAO&gt;
      &lt;/IRMAOS&gt;
      &lt;SOCIEDADES&gt;
        &lt;SOCIEDADE&gt;
          &lt;CNPJ&gt;99999999999999&lt;/CNPJ&gt;
          &lt;RAZAO_SOCIAL&gt;RAZAO SOCIAL&lt;/RAZAO_SOCIAL&gt;
          &lt;CNAE&gt;9999999&lt;/CNAE&gt;
          &lt;DESCRICAO_CNAE&gt;DESCRIÇÃO DO CNAE&lt;/DESCRICAO_CNAE&gt;
          &lt;SOCIOS&gt;
            &lt;SOCIO&gt;
              &lt;CPF&gt;99999999999&lt;/CPF&gt;
              &lt;NOME&gt;NOME DO SOCIO&lt;/NOME&gt;
              &lt;QUALIFICAO&gt;SOCIO&lt;/QUALIFICAO&gt;
              &lt;PARTICIPACAO&gt;50.00&lt;/PARTICIPACAO&gt;
              &lt;DATA_ENTRADA&gt;99/99/9999&lt;/DATA_ENTRADA&gt;
             &lt;/SOCIO&gt;
          &lt;/SOCIOS&gt;
        &lt;/SOCIEDADE&gt;
      &lt;/SOCIEDADES&gt;
      &lt;DADOS_PROFISSIONAIS&gt;
        &lt;DADOS_PROFISSIONAI&gt;
          &lt;CODIGO_OCUPACAO&gt;999999&lt;/CODIGO_OCUPACAO&gt;
          &lt;DESCRICAO_OCUPACAO&gt;OCUPAÇÃO&lt;/DESCRICAO_OCUPACAO&gt;
          &lt;CNPJ&gt;99999999999999&lt;/CNPJ&gt;
          &lt;RAZAO_SOCIAL&gt;EMPRESA&lt;/RAZAO_SOCIAL&gt;
          &lt;CNAE&gt;9999999&lt;/CNAE&gt;
          &lt;DESCRICAO_CNAE&gt;DESCRIÇÃO DO CNAE&lt;/DESCRICAO_CNAE&gt;
          &lt;PORTE&gt;MICROEMPRESA&lt;/PORTE&gt;
          &lt;CLASSIFICAO_SALARIO&gt;E&lt;/CLASSIFICAO_SALARIO&gt;
        &lt;/DADOS_PROFISSIONAI&gt;
      &lt;/DADOS_PROFISSIONAIS&gt;
  &lt;/RESPOSTA&gt;

              </pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal7">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Envio/Retorno XML Mosaico de Crédito</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>MOSAICO DE CRÉDITO</h6><br>
        <p style="font-size: 15px;">Parâmetro de solicitação para envio:</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀URL: https://www.siscredit.com.br/credital/webservices/mosaicocredito.php.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀Método: POST.</p><br>

              <h6>EXEMPLO DE ENVIO EM XML:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
  &lt;mosaicocredito&gt;
    &lt;dados&gt;
       &lt;Login&gt;8001&lt;/Login&gt;
       &lt;Token&gt;gxfaf2a102ac0457b310e96787146103&lt;/Token&gt;
       &lt;CpfCnpj&gt;99999999999&lt;/CpfCnpj&gt;
       &lt;Usuario&gt;usuario teste&lt;/Usuario&gt;
       &lt;Parcela&gt;01&lt;/Parcela&gt;
       &lt;ValorParcela&gt;10.00&lt;/ValorParcela&gt;
       &lt;Prazo&gt;120&lt;/Prazo&gt;
       &lt;PorcetagemPago&gt;10&lt;/PorcetagemPago&gt;
       &lt;ParcelaPago&gt;10&lt;/ParcelaPago&gt;
       &lt;TA&gt;120&lt;/TA&gt;
       &lt;Garantia&gt;0&lt;/Garantia&gt;
    &lt;/dados&gt;
  &lt;/mosaicocredito&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
  &lt;Resposta&gt;

       &lt;Aviso&gt;Processo Executado com Sucesso&lt;/Aviso&gt;
       &lt;Total_Registros_Recebidos&gt;1&lt;/Total_Registros_Recebidos&gt;
       &lt;linkmosaico&gt;https://www.siscredit.com.br/credital/siscred/mosaico/mosaico_axd.php?id=XXbMTQuNTc2LjE2My8wMDAxLTIx&amp;tk=f9faf2a199997b310e96787146195&lt;/linkmosaico&gt;

  &lt;/Resposta&gt;
              </pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal8">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Recebimento (Carnê, Boleto)</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size: 15px;">Endereço para envio dos Recebimento de Carnê e Boleto:</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀URL: https://www.siscredit.com.br/credital/webservices/recebimento_crediario.php.</p>
        <p style="font-size: 15px;">Parâmetro de envio:</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀Método: POST.</p>
        <br>

              <h6>EXEMPLO DE ENVIO EM XML:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
	&lt;Recebimentos&gt;
		&lt;Parcelas&gt;
			&lt;Login&gt;9999&lt;/Login&gt;
			&lt;Autorizacao&gt;99999&lt;/Autorizacao&gt;
			&lt;CpfCnpj&gt;99999999999&lt;/CpfCnpj&gt;
			&lt;Parcela&gt;1&lt;/Parcela&gt;
			&lt;ValorRecebido&gt;100.00&lt;/ValorRecebido&gt;
			&lt;DtVencimento&gt;2015-02-07&lt;/DtVencimento&gt;
			&lt;Dtpagamento&gt;2015-02-08&lt;/Dtpagamento&gt;
			&lt;UsuarioRecebimento&gt;Nome Usuario&lt;/UsuarioRecebimento&gt;
		&lt;/Parcelas&gt;
		&lt;Parcelas&gt;
			&lt;Login&gt;9999&lt;/Login&gt;
			&lt;Autorizacao&gt;99999&lt;/Autorizacao&gt;
			&lt;CpfCnpj&gt;99999999999&lt;/CpfCnpj&gt;
			&lt;Parcela&gt;2&lt;/Parcela&gt;
			&lt;ValorRecebido&gt;100.00&lt;/ValorRecebido&gt;
			&lt;DtVencimento&gt;2015-03-07&lt;/DtVencimento&gt;
			&lt;Dtpagamento&gt;2015-03-07&lt;/Dtpagamento&gt;
			&lt;UsuarioRecebimento&gt;Nome Usuario&lt;/UsuarioRecebimento&gt;
		&lt;/Parcelas&gt;
	&lt;/Recebimentos&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre>
&lt;?xml version="1.0" encoding="iso-8859-1"?&gt;
	&lt;Resposta&gt;
		&lt;Aviso&gt;Processo Executado com Sucesso&lt;/Aviso&gt;
		&lt;Total_Registros_Recebidos&gt;2&lt;/Total_Registros_Recebidos&gt;
		&lt;Total_Registros_Atualizados&gt;1&lt;/Total_Registros_Atualizados&gt;

    &lt;Alertas&gt;
        &lt;Alerta&gt;AUTORIZACAO 27554: CPF/CNPJ NAO PERTECE A AUTORIZACAO&lt;/Alerta&gt;
        &lt;Alerta&gt;LOGIN 8002: INVALIDO&lt;/Alerta&gt;
        &lt;Alerta&gt;AUTORIZACAO 9999: NAO ENCONTRADA&lt;/Alerta&gt;
    &lt;/Alertas&gt;
    &lt;/Resposta&gt;

              </pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal9">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">CreditallPay - Antifraude</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="row" style="position:relative; display: inline-block; width:108.2%;">
            <div class="col-lg-12">
                <img src="../../public/assets/images/FundoOCR.png" width="98%" style="margin-left:-12px;" />
            </div>
            <span class="mobile" style="display:;">
                <p style="position:absolute; top:25%; left: 20px; font-size: 10px; color:#FFF; width:60%;">O novo antifraude CreditallPay chegou! Mais completo e seguro de todos, desenvolvimento web para ser acessível a todos. Maior seguraça sua e praticidade para o seu cliente!</p>
                <!--<a href="exemploAntifraude.rar" target="_blank"><button style="position:absolute; top:70%; left: 20px; font-size: 16px; color:#c93d3d; background-color:#FFF; padding:7px; padding-top:11px; font-family:Myanmar Text; width:170px; border:none;" class="btn btn-danger"><b>Baixar Exemplo</b></button></a>-->
            </span>
            <span class="mobile2" style="display:;">
                <label style="position:absolute; top:10%; left: 20px; font-size: 20px; color:#FFF;">CreditallPay</label>
                <!--<a href="exemploAntifraude.rar" target="_blank"><button style="position:absolute; top:20%; left: 20px; font-size: 12px; color:#c93d3d; background-color:#FFF; padding:7px; padding-top:11px; font-family:Myanmar Text; width:120px; border:none;" class="btn btn-danger"><b>Baixar Exemplo</b></button></a>-->
            </span>
        </div>

        <div class="row" style="text-align:center; padding:15px;">
            <h3 class="classic-title" style="border-bottom: 1px solid red"><span>Sobre</span></h3>
            <br><br>
            <p>O CreditallPay antifraude é criado pela <b style="color:#BE2D2D;">Creditall Holding</b> para evitar fraudes nas compras realizadas nas lojas dos parceiros Creditall, aumentando
            a margem de vendas e diminuíndo os riscos. Para utilizar é simples, dentro da área operacional acesse "Novo Antifraude" em seguida informe o cpf ou cnpj que deseja verificar e conclua as etapas, ao terminar dará o resultado de cada etapa e a conclusão da Creditall sobre o documento em questão.</p>
        </div><br><br>


        <h6>Endereço para envio dos dados:</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/sistema/CadastroDigital/geraUrl.php.</p>

        <p style="font-size: 15px;"><strong>Tabela de Parâmetros de Envio</strong></p>
        <table width="757" border="0" class=" table table-bordered table-striped table-responsive" style="display:;">
            <tbody>
            <tr align="center" bgcolor="#9e9e9e">
                <td style="font-size: 12px" width="74" class="tit_tab">&nbsp;</td>
                <td style="font-size: 12px" width="154" class="tit_tab"><strong>Parâmetros</strong></td>
                <td style="font-size: 12px" width="77" align="center" class="tit_tab"><strong>Obrigatório</strong></td>
                <td style="font-size: 12px" width="237" class="tit_tab"><strong>Exemplo</strong></td>
                <td style="font-size: 12px" width="127" class="tit_tab"><strong>Descrição</strong></td>
                <td style="font-size: 12px" width="62" class="tit_tab"><strong>Tamanho</strong></td>
            </tr>
            <tr>
                <td style="font-size: 12px">Cliente</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">chave</td>
                <td style="font-size: 12px" align="center">sim</td>
                <td style="font-size: 12px">99753f5fc430u284c5a2ba5ea48bf316</td>
                <td style="font-size: 12px">Código Gerado pela Creditall</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">numeroControle</td>
                <td style="font-size: 12px" align="center">sim</td>
                <td style="font-size: 12px">69008</td>
                <td style="font-size: 12px">Número controle loja/site</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">url</td>
                <td style="font-size: 12px" align="center">sim</td>
                <td style="font-size: 12px">http://www.creditall.com.br/retornoAntifraude.php</td>
                <td style="font-size: 12px">Url de retorno da situações</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">Consumidor</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">cpfcnpj</td>
                <td style="font-size: 12px" align="center">sim</td>
                <td style="font-size: 12px">99000999000901</td>
                <td style="font-size: 12px">CPF, CNPJ </td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">cpfResponsavel</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">00011122233</td>
                <td style="font-size: 12px">Somente se for CNPJ</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">fundacao</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">10/01/2000</td>
                <td style="font-size: 12px">Somente se for CNPJ Formato dd/mm/YYYY</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">nascimento</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">10/01/2000</td>
                <td style="font-size: 12px">Formato dd/mm/YYYY</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px">cep</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">81000190</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">endereco</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">Av. Juscelino Kubitschek de Oliveira</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">cidade</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">CURITIBA</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">bairro</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">CIDADE INDUSTRIAL</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">uf</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">PR</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">numeroResidencia</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">9200</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">complemento</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">celular</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">4199009090</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">fixoCelular</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">4131332550</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">email</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">exemple@creditall.com.br</td>
                <td style="font-size: 12px"></td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">nomeRecado</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            </tbody>
        </table><br>

        <p style="font-size: 15px;"><strong>Tabela de Parâmetros de Retorno</strong></p>
        <table width="757" border="0" class=" table table-bordered table-striped table-responsive" style="display:;">
            <tbody>
            <tr align="center" bgcolor="#9e9e9e">
                <td style="font-size: 12px" width="74" class="tit_tab">&nbsp;</td>
                <td style="font-size: 12px" width="154" class="tit_tab"><strong>Parâmetros</strong></td>
                <td style="font-size: 12px" width="77" align="center" class="tit_tab"><strong>Obrigatório</strong></td>
                <td style="font-size: 12px" width="237" class="tit_tab"><strong>Exemplo</strong></td>
                <td style="font-size: 12px" width="127" class="tit_tab"><strong>Descrição</strong></td>
                <td style="font-size: 12px" width="62" class="tit_tab"><strong>Tamanho</strong></td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">cpfcnpj</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">99000999000901</td>
                <td style="font-size: 12px">CPF, CNPJ </td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">numeroControle</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">69008</td>
                <td style="font-size: 12px">Número controle loja/site</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">data</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px"> {{ new Date().getFullYear() }} - (data atual)</td>
                <td style="font-size: 12px">Formato YYYY-MM-DD</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            <tr>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px">resposta</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
                <td style="font-size: 12px">EM ANALISE / APROVADO / NEGADO </td>
                <td style="font-size: 12px">&nbsp;</td>
                <td style="font-size: 12px" align="center">&nbsp;</td>
            </tr>
            </tbody>
        </table>
        <br><br>

        <h6>Observações:</h6>

        <p>O retorno terá 3 resultado em resposta:</p>
        <p style="font-size: 12px;">⠀⠀⠀⠀⠀• EM ANALISE</p>
        <p style="font-size: 12px;">⠀⠀⠀⠀⠀• APROVADO</p>
        <p style="font-size: 12px;">⠀⠀⠀⠀⠀• NEGADO</p><br>
        <p>O recebimento desse resultado será via POST. Ao enviar para API ela retornará o link para iniciar o processo do antifraude.</p>


      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal10">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Pré-Análise</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Endereço para envio dos dados:</h6>
        <p style="font-size: 13px;">URL PRODUÇÃO: https://www.siscredit.com.br/credital/webservices/preanalise.php.</p><br>

        <h6>Parâmetro de envio:</h6>
        <p style="font-size: 13px;">Método: POST.</p><br>

        <h6>Nota:</h6>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀• Tag Envio (tipoconsulta):1-Crédito 2-Cheque</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀• Tag Envio (CpfRepresentante): Obrigatório quando informado CNPJ (Sócio ou Representante legal)</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀• Tag Retorno (Situacao):1-Negado 2-Aprovado</p><br>

              <h6>EXEMPLO DE ENVIO EM XML:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
&lt;?xml version="1.0" encoding="utf-8"?&gt;
	&lt;preanalise&gt;
			&lt;login&gt;9999&lt;/login&gt;
			&lt;token&gt;99999999999999999999999999999999&lt;/token&gt;
			&lt;cpfcnpj&gt;99999999999&lt;/cpfcnpj&gt;
			&lt;CpfRepresentante&gt;99999999999&lt;/CpfRepresentante&gt;
			&lt;usuario&gt;Nome Usuario&lt;/usuario&gt;
			&lt;cep&gt;99999000&lt;/cep&gt;
			&lt;cmc7&gt;&lt;/cmc7&gt;
			&lt;tipoconsulta&gt;1&lt;/tipoconsulta&gt;
	&lt;/preanalise&gt;
              </pre>
              <br>

              <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre>
&lt;?xml version="1.0" encoding="iso\-8859-1"?&gt;
		&lt;Resposta&gt;
			&lt;Numero_Controle&gt;9999&lt;/Numero_Controle&gt;
			&lt;Situacao>2&lt;/Situacao&gt;
			&lt;Nome&gt;NOME XXX&lt;/Nome&gt;
			&lt;CpfCnpj&gt;999.999.999-99&lt;/CpfCnpj&gt;
			&lt;Data_Nascimento&gt;99/99/9999&lt;/Data_Nascimento&gt;
			&lt;Limite_Maximo&gt;5.892,48&lt;/Limite_Maximo&gt;
			&lt;Limite_Parcela&gt;491,04&lt;/Limite_Parcela&gt;
			&lt;Debitos_Creditall&gt;0,00&lt;/Debitos_Creditall&gt;
			&lt;Limite_Saldo&gt;5.892,48&lt;/Limite_Saldo&gt;
			&lt;Limite_Saldo_Parcela&gt;491,04&lt;/Limite_Saldo_Parcela&gt;
		&lt;/Resposta&gt;

              </pre>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal11">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Retorno XML Compras Cartão / Boleto WEB</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Endereço de solicitação para retorno:</h6>
        <p style="font-size: 13px;">URL: https://www.siscredit.com.br/credital/webservices/cred_retorno.php</p><br>

        <h6>Parâmetro de solicitação para retorno:</h6>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀Método: GET.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀op: Tipo de Operação(COMPRAS_CREDITO).</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀ultimo_codigocontrole: Código da ultima consulta registrada.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀documento: CPF/CNPJ.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀dt_consulta: Data para pesquisa por consulta igual e superior ao informado(Formato:dmY).</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀dt_recebimento: Data para pesquisa dos recebimentos igual e superior ao informado(Formato:dmY).</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀token: Chave de Acesso.</p><br>

        <h6>Exemplo de URL:</h6>
        <p style="font-size: 13px;">https://www.siscredit.com.br/credital/webservices/cred_retorno.php?op=COMPRAS_CREDITO&ultimo_codigocontrole=90290&dt_consulta=01012016&documento=111.111.111-11&dt_recebimento=01122015&token=68753f5fc430e289c5a2ba6ea48bf996</p><br>

              <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre><!--?xml version="1.0" encoding="utf-8"?-->
 &lt;COMPRAS_CREDITO&gt;
	&lt;CONSULTA&gt;
		&lt;SITUACAO&gt;1&lt;/SITUACAO&gt;
		&lt;SITUACAO_DESC&gt;APROVADO&lt;/SITUACAO_DESC&gt;
		&lt;AUTORIZACAO&gt;90305&lt;/AUTORIZACAO&gt;
		&lt;REPASSE&gt;0&lt;/REPASSE&gt;
		&lt;DOCUMENTO&gt;999.999.999-99&lt;/DOCUMENTO&gt;
		&lt;DATA&gt;17/12/2015&lt;/DATA&gt;
		&lt;HORA&gt;10:20:03&lt;/HORA&gt;
		&lt;CONTROLE&gt;0&lt;/CONTROLE&gt;
		&lt;PRODUTO&gt;3&lt;/PRODUTO&gt;
		&lt;VALORCOMPRA&gt;1.000,00&lt;/VALORCOMPRA&gt;
		&lt;VALORTOTAL&gt;1.059,90&lt;/VALORTOTAL&gt;
		&lt;PARCELAS&gt;
			&lt;PARCELA&gt;1&lt;/PARCELA&gt;
			&lt;VENCIMENTO&gt;17/01/2016&lt;/VENCIMENTO&gt;
			&lt;VALOR_PARCELA&gt;353,30&lt;/VALOR_PARCELA&gt;
			&lt;NOSSO_NUMERO&gt;00000122&lt;/NOSSO_NUMERO&gt;
		&lt;/PARCELAS&gt;
		&lt;PARCELAS&gt;
			&lt;PARCELA&gt;2&lt;/PARCELA&gt;
			&lt;VENCIMENTO&gt;17/02/2016&lt;/VENCIMENTO&gt;
			&lt;VALOR_PARCELA&gt;353,30&lt;/VALOR_PARCELA&gt;
			&lt;NOSSO_NUMERO&gt;00000123&lt;/NOSSO_NUMERO&gt;
		&lt;/PARCELAS&gt;
		&lt;CADASTROS&gt;
			&lt;DOCUMENTO&gt;999.999.999-99&lt;/DOCUMENTO&gt;
			&lt;NOME&gt;CONSUMIDOR&lt;/NOME&gt;
			&lt;DATA_CADASTRO&gt;2015-12-17&lt;/DATA_CADASTRO&gt;
			&lt;DATA_NASCIMENTO&gt;1982-06-15&lt;/DATA_NASCIMENTO&gt;
			&lt;CEP&gt;81.999-999&lt;/CEP&gt;
			&lt;ENDERECO&gt;RUA XV NOVEMBRO&lt;/ENDERECO&gt;
			&lt;NUMERO_ENDERECO&gt;999&lt;/NUMERO_ENDERECO&gt;
			&lt;BAIRRO&gt;CENTRO&lt;/BAIRRO&gt;
			&lt;CIDADE&gt;CURITIBA&lt;/CIDADE&gt;
			&lt;UF&gt;PR&lt;/UF&gt;
			&lt;DDD_FIXO&gt;41&lt;/DDD_FIXO&gt;
			&lt;TELEFONE_FIXO&gt;3333-33333&lt;/TELEFONE_FIXO&gt;
			&lt;DDD_CELULAR&gt;41&lt;/DDD_CELULAR&gt;
			&lt;TELEFONE_CELULAR&gt;9999-9999&lt;/TELEFONE_CELULAR&gt;
			&lt;EMAIL&gt;consumidor@gmail.com&lt;/EMAIL&gt;
		&lt;/CADASTROS&gt;
	&lt;/CONSULTA&gt;
	&lt;RECEBIMENTOS&gt;
		&lt;PARCELAS&gt;
			&lt;PARCELA&gt;90210&lt;/PARCELA&gt;
			&lt;PARCELA&gt;1&lt;/PARCELA&gt;
			&lt;DTVENCIMENTO&gt;22/11/2015&lt;/DTVENCIMENTO&gt;
			&lt;VALOR_PARCELA&gt;248,84&lt;/VALOR_PARCELA&gt;
			&lt;DTPAGAMENTO&gt;16/12/2015&lt;/DTPAGAMENTO&gt;
			&lt;VALOR_PAGO&gt;255,81&lt;/VALOR_PAGO&gt;
		&lt;/PARCELAS&gt;
		&lt;PARCELAS&gt;
			&lt;PARCELA&gt;90210&lt;/PARCELA&gt;
			&lt;PARCELA&gt;9&lt;/PARCELA&gt;
			&lt;DTVENCIMENTO&gt;22/07/2016&lt;/DTVENCIMENTO&gt;
			&lt;VALOR_PARCELA&gt;248,84&lt;/VALOR_PARCELA&gt;
			&lt;DTPAGAMENTO&gt;16/12/2015&lt;/DTPAGAMENTO&gt;
			&lt;VALOR_PAGO&gt;248,84&lt;/VALOR_PAGO&gt;
		&lt;/PARCELAS&gt;
	&lt;/RECEBIMENTOS&gt;
&lt;/COMPRAS_CREDITO&gt;
              </pre>
              <br>

        <h6>Situações</h6>
        <p style="font-size: 13px;">1 - Negado Cadastro / Compra (Autorização nº4 = "Cadastro Negado", Sem Autorização = "Compra Negado")</p>
        <p style="font-size: 13px;">2 - Aprovado Cadastro / Compra( Autorização nº2 = "Emissão Cartão", Autorização nº3 = "Cadastro Aprovado", Autorização nº5 = "Consulta Credito",Autorização > Superior 5 = "Compra Aprovada" )</p>
        <p style="font-size: 13px;">3 - Compra Cancelada</p>
        <br>

        <h6>Produto</h6>
        <p style="font-size: 13px;">1 - Cartão Compras</p>
        <p style="font-size: 13px;">2 - Compras Boleto</p>
        <p style="font-size: 13px;">3 - Compras Carnê</p>
        <br>



      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal12">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Retorno XML Consulta Cheque</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h6>Parâmetro de solicitação para retorno:</h6>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀Método: GET.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀op: Tipo de Operação(COMPRAS_CHEQUE).</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀ultima_proposta: Código da ultima consulta registrada.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀documento: CPF/CNPJ.</p>
        <p style="font-size: 13px;">⠀⠀⠀⠀⠀token: Chave de Acesso.</p><br>

        <h6>Exemplo de URL:</h6>
        <p style="font-size: 13px;">https://www.siscredit.com.br/credital/webservices/cred_retorno.php?op=COMPRAS_CHEQUE&ultima_proposta=99999&documento=99999999999&token=f9F9F9F9F9F9F9F9F9F</p><br>

        <h6>EXEMPLO DE RETORNO EM XML:</h6>
              <pre>&lt;COMPRAS_CHEQUE&gt;<br>&nbsp;&nbsp;&lt;CONSULTA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;SITUACAO&gt;NEGADO&lt;/SITUACAO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;CONTROLE&gt;0&lt;/CONTROLE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PRODUTO&gt;1&lt;/PRODUTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;REPASSE&gt;0&lt;/REPASSE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;DOCUMENTO&gt;999.999.999-53&lt;/DOCUMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;DATA&gt;22/05/2017&lt;/DATA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;HORA&gt;10:00:23&lt;/HORA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALORCOMPRA&gt;120,99&lt;/VALORCOMPRA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALORTOTAL&gt;120,99&lt;/VALORTOTAL&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;CADASTROS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DOCUMENTO&gt;999.999.999-53&lt;/DOCUMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DATA_NASCIMENTO&gt;23/03/1947&lt;/DATA_NASCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DATA_CADASTRO&gt;22/05/2017&lt;/DATA_CADASTRO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NOME&gt;JOAO&nbsp;TESTE&lt;/NOME&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CEP&gt;13484333&lt;/CEP&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;ENDERECO&gt;MANOEL&nbsp;FERRAZ&nbsp;CAMARGO&lt;/ENDERECO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_ENDERECO&gt;140&lt;/NUMERO_ENDERECO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;BAIRRO&gt;JD&nbsp;PIRATININGA&lt;/BAIRRO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CIDADE&gt;LIMEIRA&lt;/CIDADE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;UF&gt;SP&lt;/UF&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DDD_FIXO&gt;19&lt;/DDD_FIXO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;TELEFONE_FIXO&gt;3999-9999&lt;/TELEFONE_FIXO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DDD_CELULAR&gt;19&lt;/DDD_CELULAR&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;TELEFONE_CELULAR&gt;99999-99999&lt;/TELEFONE_CELULAR&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/CADASTROS&gt;<br>&nbsp;&nbsp;&lt;/CONSULTA&gt;<br>&nbsp;&nbsp;&lt;CONSULTA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;SITUACAO&gt;APROVADO&lt;/SITUACAO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;AUTORIZACAO&gt;11112222&lt;/AUTORIZACAO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;CONTROLE&gt;0&lt;/CONTROLE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PRODUTO&gt;1&lt;/PRODUTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;REPASSE&gt;0&lt;/REPASSE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;DOCUMENTO&gt;999.999.999-53&lt;/DOCUMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;DATA&gt;22/05/2017&lt;/DATA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;HORA&gt;11:55:59&lt;/HORA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALORCOMPRA&gt;3.510,00&lt;/VALORCOMPRA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALORTOTAL&gt;3.510,00&lt;/VALORTOTAL&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000041&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;8&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;033361300180000415897010802136&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;1&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/05/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000042&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;6&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;2&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/06/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000043&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;4&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;3&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/07/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000044&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;2&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;4&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/08/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000045&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;0&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;5&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/09/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000046&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;9&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;6&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/10/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000047&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;7&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;7&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/11/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_CHEQUE&gt;000048&lt;/NUMERO_CHEQUE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_C3&gt;5&lt;/NUMERO_C3&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CMC7&gt;000000000000000000000000000000&lt;/CMC7&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;PARCELA&gt;8&lt;/PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VENCIMENTO&gt;30/12/2017&lt;/VENCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;VALOR_PARCELA&gt;438,75&lt;/VALOR_PARCELA&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/PARCELAS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;CADASTROS&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DOCUMENTO&gt;999.999.999-53&lt;/DOCUMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DATA_NASCIMENTO&gt;07/06/1973&lt;/DATA_NASCIMENTO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DATA_CADASTRO&gt;22/05/2017&lt;/DATA_CADASTRO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NOME&gt;JOAO&nbsp;TESTE&lt;/NOME&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CEP&gt;09970160&lt;/CEP&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;ENDERECO&gt;ANTONIO&nbsp;SYLVIO&nbsp;CUNHA&nbsp;BUENO&lt;/ENDERECO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;NUMERO_ENDERECO&gt;1068&lt;/NUMERO_ENDERECO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;BAIRRO&gt;INAMAR&lt;/BAIRRO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;CIDADE&gt;DIADEMA&lt;/CIDADE&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;UF&gt;SP&lt;/UF&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DDD_FIXO&gt;11&lt;/DDD_FIXO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;TELEFONE_FIXO&gt;3333-9999&lt;/TELEFONE_FIXO&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;DDD_CELULAR&gt;11&lt;/DDD_CELULAR&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;TELEFONE_CELULAR&gt;99999-9999&lt;/TELEFONE_CELULAR&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/CADASTROS&gt;<br>&nbsp;&nbsp;&lt;/CONSULTA&gt;<br>&lt;/COMPRAS_CHEQUE&gt;<br>
</pre>
              <br>

      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal13">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Autenticação 
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
    <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/auth/login
  </p>
  <p style="font-size:13px; margin-top:0.25rem;">
    <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/auth/login
  </p>

  <hr>

  <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
  <p style="font-size:13px; margin:0.25rem 0;">
    A autenticação é realizada via <code>application/json</code>, exigindo credenciais de acesso.
  </p>
  <table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
    <thead>
      <tr>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>login</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">integer</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>9999</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Identificador do usuário no sistema (login concedido pela plataforma).</td>
      </tr>
      <tr>
        <td style="padding:6px 8px;"><code>password</code></td>
        <td style="padding:6px 8px;">string</td>
        <td style="padding:6px 8px;">Sim</td>
        <td style="padding:6px 8px;"><code>"91548741274"</code></td>
        <td style="padding:6px 8px;">Senha customizada associada ao login informado.</td>
      </tr>
    </tbody>
  </table>
  <br>
  <h6 style="margin-bottom:0.25rem;">Exemplo de requisição (Request Body)</h6>
  <pre style="background:#f7f7f7; padding:10px; border-radius:4px; font-size:13px; overflow:auto;">
{
  "login": 9999,
  "password": "91548741274"
}
  </pre>
        <br>
        <h6>EXEMPLO DE RETORNO:</h6>
          <p style="display:inline; color: green; font-weight: bold;">(SUCESSO)</p>
          <pre>
{
  "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6ODA3NSwidXNlcklkIjo2NSwiaWF0IjoxNzU4MjA0Njc2fQ.nL5a9ayR7Xvxa-qXwTFaQ91Csill2I9-bFE0tEFpAa4"
}
          </pre>
          <br>
          <p style="display:inline; color: red; font-weight: bold;">(ERRO)</p>
          <pre>
{
    "statusCode": 401,
    "error": "Credenciais inválidas",
    "errors": []
}
          </pre>
          
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal14">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Pré-Análise de Crédito
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
    <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/credit/v1/pre-analysis
  </p>
  <p style="font-size:13px; margin-top:0.25rem;">
    <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/credit/v1/pre-analysis
  </p>

  <hr>

  <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
  <p style="font-size:13px; margin:0.25rem 0;">
    Envie o corpo da requisição em <code>application/json</code>. Abaixo estão os campos aceitos.
  </p>
  <table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
    <thead>
      <tr>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>doc</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>99.999.999/9999-99</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Documento do cliente a ser analisado (pode ser CNPJ ou CPF).</td>
      </tr>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>responsible</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>999.999.999-99</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Documento do responsável (ex.: sócio, avalista, responsável legal). 
    <strong>Obrigatório quando o campo <code>doc</code> for um CNPJ</strong>, 
    e opcional quando <code>doc</code> for um CPF.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>zipCode</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>80.050-000</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">CEP do endereço relacionado à análise de crédito.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px;"><code>intentToBuy</code></td>
        <td style="padding:6px 8px;">integer</td>
        <td style="padding:6px 8px;">Não</td>
        <td style="padding:6px 8px;"><code>100</code></td>
        <td style="padding:6px 8px;">Valor estimado de intenção de compra, utilizado como referência para a pré-análise.</td>
      </tr>
    </tbody>
  </table>
  <br>
  <h6 style="margin-bottom:0.25rem;">Exemplo de requisição (Request Body)</h6>
  <pre style="background:#f7f7f7; padding:10px; border-radius:4px; font-size:13px; overflow:auto;">
{
  "doc": "99.999.999/9999-99",
  "responsible": "999.999.999-99",
  "zipCode": "80.050-000",
  "intentToBuy": 100
}
  </pre>

  <p style="font-size:12px; margin-top:0.5rem; color:#555;">
    <em>Observação:</em> O campo <code>doc</code> é essencial para a análise. Os demais campos fornecem contexto adicional e podem influenciar a qualidade do resultado.
  </p>
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>
{
  "statusCode": 201,
  "message": "Successfully client pre-analysis",
  "data": {
    "doc": "999.999.999-99",
    "credit": 200.0
    "purchasePower": 800.0
    "errors": [] 
  }
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal15">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Análise de Crédito completa
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
  <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/credit/v1/analysis
</p>
<p style="font-size:13px; margin-top:0.25rem;">
  <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/credit/v1/analysis
</p>

<hr>

<h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
<p style="font-size:13px; margin:0.25rem 0;">
  Envie o corpo da requisição em <code>application/json</code>. Abaixo estão os campos aceitos.
</p>

<table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
  <thead>
    <tr>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>personal.doc</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>99.999.999/9999-99</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Documento do cliente (CPF ou CNPJ) a ser analisado.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>personal.responsible</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>999.999.999-99</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Documento do responsável (ex.: sócio, avalista, responsável legal). <strong>Obrigatório quando <code>doc</code> for um CNPJ</strong>.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>personal.birthDate</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string (yyyy-MM-dd)</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>1990-05-20</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Data de nascimento do cliente (somente quando <code>doc</code> for CPF).</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>contact.email</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>contato@mockempresa.com</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">E-mail de contato do cliente.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>contact.phoneDDD</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>41</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">DDD do telefone principal.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>contact.phoneNumber</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>33445566</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Telefone principal do cliente.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>contact.phoneMessage</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>998877665</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Telefone secundário do cliente. <strong>Obrigatório ser diferente</strong> do <em>phoneNumber</em>.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>address</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">object</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>{ city, state, street, zipCode, neighborhood, number }</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Endereço completo do cliente.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>identification</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">object</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>{ type, number, day, month, year, validity }</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Dados da CNH (quando aplicável).</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>bank</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">object</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>{ bankCode, agency, account, validity, number }</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Informações bancárias do cliente.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px;"><code>intentToBuy</code></td>
      <td style="padding:6px 8px;">number</td>
      <td style="padding:6px 8px;">Não</td>
      <td style="padding:6px 8px;"><code>500.0</code></td>
      <td style="padding:6px 8px;">Valor estimado de intenção de compra.</td>
    </tr>
  </tbody>
</table>

<br>
<h6 style="margin-bottom:0.25rem;">Exemplo de requisição (Request Body)</h6>
<pre style="background:#f7f7f7; padding:10px; border-radius:4px; font-size:13px; overflow:auto;">
{
  "personal": {
    "doc": "99.999.999/9999-99",
    "responsible": "999.999.999-99",
    "birthDate": "1990-05-20"
  },
  "contact": {
    "email": "contato@mockempresa.com",
    "phoneDDD": "41",
    "phoneNumber": "33445566",
    "phoneMessage": "998877665",
    "phoneMessageDDD": "41",
    "phoneMessageName": "João Silva"
  },
  "address": {
    "city": "Curitiba",
    "state": "PR",
    "street": "Av. Sete de Setembro",
    "zipCode": "80050-000",
    "neighborhood": "Centro",
    "number": 1234
  },
  "identification": {
    "cnh": {
      "type": 1,
      "number": "12345678900",
      "day": "15",
      "month": "06",
      "year": "2022",
      "validity": "15/06/2032"
    }
  },
  "bank": {
    "bankCode": "001",
    "agency": "4321",
    "account": "98765-0",
    "validity": "12/30",
    "number": "12345678"
  },
  "intentToBuy": 500.0
}
</pre>
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>
{
  "statusCode": 202,
  "message": "Successfully client analysis",
  "data": {
    "doc": "999.999.999-99",
    "credit": 200.0
    "purchasePower": 800.0
    "errors": [] 
  }
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal16">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Simulador de Parcelas
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
  <p style="font-size:13px; margin-bottom:0.25rem;">
    <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/order/v1/preview
  </p>
  <p style="font-size:13px; margin-top:0.25rem;">
    <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/order/v1/preview
  </p>
  <hr>
  <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
  <p style="font-size:13px; margin:0.25rem 0;">
    Envie o corpo da requisição em <code>application/json</code>. Abaixo estão os campos aceitos.
  </p>
  <table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
    <thead>
      <tr>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
        <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>doc</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>999.999.999-99</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">CPF ou CNPJ. Formatos aceitos: <code>999.999.999-99</code> ou <code>99.999.999/9999-99</code>.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>dueDate</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>2025-09-19</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Data da Primeira parcela no formato ISO <code>YYYY-MM-DD</code>.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>installmentsQty</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">integer</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>10</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Quantidade de parcelas desejadas.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>amount</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">decimal</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>100.00</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Valor total da operação. Use ponto como separador decimal.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>InstallmentInterval</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">integer</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>30</code></td>
        <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Intervalo de dias entre as parcelas da operação.</td>
      </tr>
      <tr>
        <td style="padding:6px 8px;"><code>paymentType</code></td>
        <td style="padding:6px 8px;">string</td>
        <td style="padding:6px 8px;">Sim</td>
        <td style="padding:6px 8px;"><code>"SLIP"</code></td>
        <td style="padding:6px 8px;">
          Tipo de pagamento. Valores aceitos: 
          <ul style="margin:4px 0 0 16px; padding:0; list-style-type: disc;">
            <li><code>SLIP</code> — Boleto bancário</li>
            <li><code>PIX</code> — Pagamento instantâneo via PIX</li>
            <li><code>RECURRENCE</code> — Pagamento recorrente</li>
          </ul>
        </td>
        <!-- <td style="padding:6px 8px;">Tipo de pagamento. Ex.: <code>"SLIP"</code> para boleto bancário.</td> -->
      </tr>
    </tbody>
  </table>
  <br>
  <h6 style="margin-bottom:0.25rem;">Exemplo de requisição (Request Body)</h6>
  <pre style="background:#f7f7f7; padding:10px; border-radius:4px; font-size:13px; overflow:auto;">
{
  "doc": "999.999.999-99",
  "dueDate": "2025-09-19",
  "installmentsQty": 10,
  "amount": 100.00,
  "InstallmentInterval": 30,
  "paymentType": "SLIP"
}
  </pre>

  <p style="font-size:12px; margin-top:0.5rem; color:#555;">
    <em>Observação:</em> valide campos do lado do cliente e do servidor. Não confie apenas no formato apresentado — trate CPF/CNPJ (validar dígitos), limites de valor e quantidade de parcelas antes de enviar para produção.
  </p>
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>
{
    "statusCode": 200,
    "message": "Preview of order generated",
    "data": {
        "id": "e5f3076a-64a2-420b-9501-80d66c38bgg9",
        "doc": "999.999.999-99",
        "simulatedDate": "9999-99-99",
        "firstDueDate": "9999-99-99",
        "intervalDays": 30,
        "paymentType": "SLIP",
        "currency": "BRL",
        "resumed": [ 
            {
                "plan": 1,
                "totalInstallments": 1,
                "installmentValue": 154.8,
                "total": 154.8
            },
            {
                "plan": 2,
                "totalInstallments": 2,
                "installmentValue": 78.56,
                "total": 157.12
            },
            {
                "plan": 3,
                "totalInstallments": 3,
                "installmentValue": 53.164,
                "total": 159.49
            },
            {
                "plan": 4,
                "totalInstallments": 4,
                "installmentValue": 40.48,
                "total": 161.92
            },
            {
                "plan": 5,
                "totalInstallments": 5,
                "installmentValue": 32.874,
                "total": 164.37
            },
            {
                "plan": 6,
                "totalInstallments": 6,
                "installmentValue": 27.791,
                "total": 166.75
            },
            {
                "plan": 7,
                "totalInstallments": 7,
                "installmentValue": 24.165,
                "total": 169.15
            },
            {
                "plan": 8,
                "totalInstallments": 8,
                "installmentValue": 21.445,
                "total": 171.56
            },
            {
                "plan": 9,
                "totalInstallments": 9,
                "installmentValue": 19.331,
                "total": 173.98
            },
            {
                "plan": 10,
                "totalInstallments": 10,
                "installmentValue": 17.64,
                "total": 176.4
            },
        ]
    }
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal17">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Finalizar Venda
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
          <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/order/v1/create
        </p>
        <p style="font-size:13px; margin-top:0.25rem;">
          <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/order/v1/create
        </p>
        <hr>
        <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
        <p style="font-size:13px; margin:0.25rem 0;">
          Envie o corpo da requisição em <code>application/json</code>. Abaixo estão os campos aceitos.
        </p>
        <table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
          <thead>
            <tr>
              <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
              <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
              <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
              <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
              <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>id</code></td>
              <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string (UUID)</td>
              <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
              <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>8033a5ad-82a2-4256-a083-1d79d9621c7d</code></td>
              <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Identificador único da ordem gerada previamente na etapa de <em>preview</em>. Esse <code>id</code> é utilizado para confirmar/criar o pedido final.</td>
            </tr>
          </tbody>
        </table>
        <br>
        <h6 style="margin-bottom:0.25rem;">Exemplo de requisição (Request Body)</h6>
        <pre style="background:#f7f7f7; padding:10px; border-radius:4px; font-size:13px; overflow:auto;">
{
  "id": "8033a5ad-82a2-4256-a083-1d79d9621c7d"
}
          </pre>
          <p style="font-size:12px; margin-top:0.5rem; color:#555;">
            <em>Observação:</em> utilize o <code>id</code> retornado pela chamada de <strong>Preview</strong>. IDs inválidos ou expirados resultarão em erro de processamento. 
          </p>
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>
{
  "statusCode": 201,
  "message": "Successfully created order",
  "data": {
    "id": 555555,
    "doc": "999.999.999-99",
    "installmentsQty": 5,
    "operationDate": "2025-01-18",
    "paymentType": "SLIP",
    "totalAmount": 1500.0,
    "totalWithInterest": 1607.4,
    "link": "https://siscredit.com.br/sistema/geradorBFaturaV1.php?p=0&numero=555555&",
    "installments": [
      {
        "installment": 1,
        "dueDate": "2025-02-17",
        "installmentValue": 300,
        "amountWithInterest": 321.48,
        "status": "PENDING",
        "paymentDate": null,
        "amountPaid": 0,
        "note": "etc"
      },
      {
        "installment": 2,
        "dueDate": "2025-03-17",
        "installmentValue": 300,
        "status": "PENDING",
        "paymentDate": null,
        "amountPaid": 0,
        "note": "etc"
      },
      {
        "installment": 3,
        "dueDate": "2025-04-17",
        "installmentValue": 300,
        "amountWithInterest": 321.48,
        "status": "PENDING",
        "paymentDate": null,
        "amountPaid": 0,
        "note": "etc"
      },
      {
        "installment": 4,
        "dueDate": "2025-06-17",
        "installmentValue": 300,
        "amountWithInterest": 321.48,
        "status": "PENDING",
        "paymentDate": null,
        "amountPaid": 0,
        "note": "etc"
      },
      {
        "installment": 5,
        "dueDate": "2025-07-17",
        "installmentValue": 300,
        "amountWithInterest": 321.48,
        "status": "PENDING",
        "paymentDate": null,
        "amountPaid": 0,
        "note": "etc"
      }
    ]
  }
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal18">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: green; font-weight: bold;">[GET]</p>
          Listagem de Vendas
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
          <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/order/v1
        </p>
        <p style="font-size:13px; margin-top:0.25rem;">
          <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/order/v1
        </p>
        <hr>
        <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
        <p style="font-size:13px; margin:0.25rem 0;">
  Envie como parametros os campos aceitos abaixo.
</p>
<table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
  <thead>
    <tr>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>order</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">number</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>555555</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Identificador da consulta a ser realizada.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>doc</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>999.999.999-99</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Identificador da consulta a ser realizada.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>startDate</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string (ISO 8601)</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>2025-09-19</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Data da consulta no formato <code>YYYY-MM-DD</code>.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>endDate</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string (ISO 8601)</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>2025-09-19</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Data consulta no formato <code>YYYY-MM-DD</code>.</td>
    </tr>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>status</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Não</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>PENDING</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">
        <strong>Status: </strong>
        <code>PENDING</code> | 
        <code>CANCELLED</code> | 
        <code>PAID</code> | 
        <code>OVERDUE</code> | 
        <code>DISPUTED</code>
      </td>
    </tr>
  </tbody>
</table>
<br>
<!-- <h6 style="margin-bottom:0.25rem;">Exemplo de requisição (Request Body)</h6>
<pre style="background:#f7f7f7; padding:10px; border-radius:4px; font-size:13px; overflow:auto;">
{
  "order": "555555",
  "doc": "999.999.999-99",
  "startDate": "2025-09-19"
  "endDate": "2025-09-19"
}
</pre> -->
          <!-- <p style="font-size:12px; margin-top:0.5rem; color:#555;">
            <em>Observação:</em> utilize o <code>id</code> retornado pela chamada de <strong>Preview</strong>. IDs inválidos ou expirados resultarão em erro de processamento. 
          </p> -->
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>
{
  "statusCode": 201,
  "message": "Successfully created order",
  "data": [
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 1,
      "dueDate": "2025-02-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "PAID",
      "paymentDate": '2025-02-11',
      "cancelledDate": null,
      "amountPaid": 321.48,
      "payoutDate": '2025-02-15',
      "refundDate": null
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 2,
      "dueDate": "2025-03-17",
      "installmentValue": 300,
      "status": "DISPUTED",
      "paymentDate": null,
      "cancelledDate": null,
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": null,
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 3,
      "dueDate": "2025-04-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "OVERDUE",
      "paymentDate": null,
      "cancelledDate": null,
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": '2025-05-31'
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 4,
      "dueDate": "2025-06-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "PENDING",
      "paymentDate": null,
      "cancelledDate": null,
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": null
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 5,
      "dueDate": "2025-07-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "CANCELLED",
      "paymentDate": null,
      "cancelledDate": '2025-03-20',
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": null
    }
  ]
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------->
<div class="modal" tabindex="-1" id="modal19">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Cadastro de Webhooks
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
          <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/webhooks/v1/register
        </p>
        <p style="font-size:13px; margin-top:0.25rem;">
          <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/webhooks/v1/register
        </p>
        <hr>
        <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
        <p style="font-size:13px; margin:0.25rem 0;">
  Envie como parametros os campos aceitos abaixo.
</p>
<table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
  <thead>
    <tr>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Campo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Tipo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Obrigatório</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Exemplo</th>
      <th style="text-align:left; padding:6px 8px; border-bottom:1px solid #ddd;">Descrição</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>url</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">string</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Sim</td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;"><code>https://siscredit.com.br/creditall/webhook</code></td>
      <td style="padding:6px 8px; border-bottom:1px solid #f0f0f0;">Identificador de solicitação a ser realizada.</td>
    </tr>
  </tbody>
</table>
<br>
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>
{
    "statusCode": 201,
    "message": "Webhook registered successfully",
    "data": {
        "url": "http://exemplo",
        "login": 8002
    }
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" id="modal20">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <p style="display:inline; color: orange; font-weight: bold;">[POST]</p>
          Webhooks
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p style="font-size:13px; margin-bottom:0.25rem;">
          <strong>URL PRODUÇÃO:</strong> https://api.siscredit.com.br/creditall/webhooks/v1/register
        </p>
        <p style="font-size:13px; margin-top:0.25rem;">
          <strong>URL HOMOLOGAÇÃO:</strong> https://sandbox.siscredit.com.br/creditall/webhooks/v1/register
        </p>
        <hr>
        <!-- <h6 style="margin-top:0.5rem;">Parâmetro de solicitação</h6>
        <p style="font-size:13px; margin:0.25rem 0;">
  Envie como parametros os campos aceitos abaixo.
</p> -->
<table style="width:100%; border-collapse:collapse; font-size:13px; margin-top:0.5rem;">
</table>
<br>
        <br>
        <h6>Exemplo de retorno (Response - JSON)</h6>
        <pre>

    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 1,
      "dueDate": "2025-02-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "PAID",
      "paymentDate": '2025-02-11',
      "cancelledDate": null,
      "amountPaid": 321.48,
      "payoutDate": '2025-02-15',
      "refundDate": null
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 2,
      "dueDate": "2025-03-17",
      "installmentValue": 300,
      "status": "DISPUTED",
      "paymentDate": null,
      "cancelledDate": null,
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": null,
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 3,
      "dueDate": "2025-04-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "OVERDUE",
      "paymentDate": null,
      "cancelledDate": null,
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": '2025-05-31'
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 4,
      "dueDate": "2025-06-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "PENDING",
      "paymentDate": null,
      "cancelledDate": null,
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": null
    },
    {
      "doc": "999.999.999-99",
      "order": 555555,
      "installment": 5,
      "dueDate": "2025-07-17",
      "installmentValue": 300,
      "amountWithInterest": 321.48,
      "status": "CANCELLED",
      "paymentDate": null,
      "cancelledDate": '2025-03-20',
      "amountPaid": 0,
      "payoutDate": null,
      "refundDate": null
    }
  ]
}
        </pre>
      </div>
      <div class="modal-footer" style="justify-content: flex-start;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

</section>
  <Footer />
</template>
<script>
import Footer from "../components/Footer.vue";
import TopBar from "../components/TopBar.vue";
export default {
  name: "Dev",
  components: {
    TopBar,
    Footer,
  },

};
</script>

<style scoped>
@media only screen and (max-width: 320px) {
  span p {
    font-size: 10px;
  }
}

@media only screen and (min-width: 321px) and (max-width: 768px) {
  span p {
    font-size: 10px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  span p {
    font-size: 10px;
  }
}


pre {
  display:block;
  padding:9.5px;
  margin:0 0 10px;
  font-size:13px;
  line-height:1.42857143;
  color:#333;
  word-break:break-all;
  word-wrap:break-word;
  background-color:#f5f5f5;
  border:1px solid #ccc;
  border-radius:4px
}


.modal-content {
    height: 100%;
    width: 100%;
}

.breadcrumbs {
  padding: 45px 0;
  margin-top: 4rem;
  background: #efefef;
}
@media only screen and (max-width: 320px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

@media only screen and (min-width: 321px) and (max-width: 768px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

.breadcrumbs h2 {
  font-size: 26px;
  font-weight: 600;
}
.breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 0 10px 0;
  margin: 0;
  font-size: 14px;
}
.breadcrumbs ol li + li {
  padding-left: 10px;
}
.breadcrumbs ol li + li::before {
  display: inline-block;
  padding-right: 10px;
  color: #333333;
  content: "/";
}

.contato .info-box {
  color: #444444;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px 0 30px 0;
  padding: 20px;
  text-decoration: none;
  min-height: 170px;
  background-color: #fafafa;
}
.contato .info-box i {
  font-size: 52px;
  color: #cc1616;
}
.contato .info-box h3 {
  font-size: 20px;
  color: #444;
  font-weight: 700;
  margin: 10px 0;
}
.contato .info-box p {
  padding: 0;
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
  color: #777;
}

@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .contato .info-box {
    width: auto;
    margin: 0 auto;
    padding: 2rem 0 1.875rem 0;
  }

  .contato .info-box p {
    font-size: 12px;
  }
}

</style>
